module.exports = __webpack_public_path__ + "static/media/MinistryOfDefence.2ab66405.png";